import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

 var swiper = new Swiper(".section1 .mySwiper", {
    spaceBetween: 15,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: 15,
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于768
            spaceBetween: 15,
            slidesPerView: 3,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 10,
            slidesPerView: 2,
        }
    } 
});
var swiper2 = new Swiper(".section1 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});

var messagePic = new Swiper(".section5 .pic", {
    
});
var message = new Swiper(".section5 .mySwiper", {
    navigation: {
    nextEl: ".swiper-control .swiper-button-next",
    prevEl: ".swiper-control .swiper-button-prev",
    },
    thumbs: {
        swiper: messagePic,
    },
});

var swiper7 = new Swiper(".section7 .mySwiper", {
    spaceBetween: '1.82%',
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.82%',
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于768
            spaceBetween: '1.82%',
            slidesPerView: 3,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 10,
            slidesPerView: 2,
        }
    } ,
    navigation: {
        nextEl: ".section7 .swiper-button-next",
        prevEl: ".section7 .swiper-button-prev",
    },
});